// @flow
import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

type Props = $ReadOnly<{
    open: boolean,
    preset: $ReadOnly<{}>,

    onClose: () => void,
    onSave: (preset: $ReadOnly<{}>) => void
}>;
function SaveDialog({ open, preset, onClose, onSave }: Props) {
    const [title, setTitle] = useState(preset.title);

    useEffect(() => setTitle(preset.title), [preset.title]);

    const handleChange = (e) => setTitle(e.target.value);

    const handleSave = () => {
        onSave({
            ...preset,
            title: title
        });
    };

    return (
        <Dialog open={open} onClose={onClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">
                <FormattedMessage
                    id="tisPlayer.generator.savePrese.title"
                    defaultMessage="Save preset as"
                />
            </DialogTitle>
            <DialogContent>
                <TextField
                    value={title || ''}
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Name"
                    type="text"
                    fullWidth
                    onChange={handleChange}
                    variant="filled"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    <FormattedMessage
                        id="tisPlayer.generator.savePreset.cancel"
                        defaultMessage="Cancel"
                    />
                </Button>
                <Button onClick={handleSave} color="primary">
                    <FormattedMessage
                        id="tisPlayer.generator.savePreset.save"
                        defaultMessage="Save"
                    />
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default SaveDialog;